// Translations
import accessKeyManagingDialog from '../components/access-key-managing-dialog/translations/ua'

// Translation: Model > Access key manager (Ukrainian)
export default Object.freeze({
	actions: {
		create: {
			hint: '',
			text: ''
		}
	},
	components: { accessKeyManagingDialog }
})
